<template>
	<!-- 当有editing类时， 表示处于编辑状态，可以拖拽缩放 -->
<!--  -->
	<div class="componentsWrapper" :class="{'editing': editable && (editing || multiEditing)}" @click="clickOnWrapper" @mousedown="mouseDownOnSelf"
       :style="{'border': this.borderColor}">
		<!-- 用于填充组件 -->
		<slot name="wrapped">
		</slot>
		<!-- 八个用于拖拽缩放的方块 -->
		<div >
			<div v-show="editable && (editing || multiEditing)" @mousedown.stop="mouseDownOnScale($event, 'nw')" @click.stop
				:style="{backgroundColor: this.wrapperColor, width: this.scaleBlockSize+'px', height: this.scaleBlockSize+'px' }"
           class="nw scaleIcon"></div>

      <div v-show="editable && (editing || multiEditing)" @mousedown.stop="mouseDownOnScale($event, 'n')" @click.stop

           :style="{backgroundColor: this.wrapperColor, width: this.scaleBlockSize+'px', height: this.scaleBlockSize+'px',left: (this.wrapperStyleMergeinfo.width/2-3)+'px'}"
           class="n scaleIcon"></div>

      <div v-show="editable && (editing || multiEditing)" @mousedown.stop="mouseDownOnScale($event, 'ne')" @click.stop
				:style="{backgroundColor: this.wrapperColor, width: this.scaleBlockSize+'px', height: this.scaleBlockSize+'px'}"
           class="ne scaleIcon"></div>

      <div v-show="editable && (editing || multiEditing)" @mousedown.stop="mouseDownOnScale($event, 'w')" @click.stop
           :style="{backgroundColor: this.wrapperColor, width: this.scaleBlockSize+'px', height: this.scaleBlockSize+'px',top: (this.wrapperStyleMergeinfo.height/2-3)+'px' }"
           class="w scaleIcon"></div>

      <div v-show="editable && (editing || multiEditing)" @mousedown.stop="mouseDownOnScale($event, 'e')" @click.stop
           :style="{backgroundColor: this.wrapperColor, width: this.scaleBlockSize+'px', height: this.scaleBlockSize+'px',top: (this.wrapperStyleMergeinfo.height/2-3)+'px' }"
           class="e scaleIcon"></div>

      <div v-show="editable && (editing || multiEditing)" @mousedown.stop="mouseDownOnScale($event, 'sw')" @click.stop
           :style="{backgroundColor: this.wrapperColor, width: this.scaleBlockSize+'px', height: this.scaleBlockSize+'px'}"
           class="sw scaleIcon"></div>

      <div v-show="editable && (editing || multiEditing)" @mousedown.stop="mouseDownOnScale($event, 's')" @click.stop
           :style="{backgroundColor: this.wrapperColor, width: this.scaleBlockSize+'px', height: this.scaleBlockSize+'px',left: (this.wrapperStyleMergeinfo.width/2-3)+'px' }"
           class="s scaleIcon"></div>

      <div v-show="editable && (editing || multiEditing)" @mousedown.stop="mouseDownOnScale($event, 'se')" @click.stop
           :style="{backgroundColor: this.wrapperColor, width: this.scaleBlockSize+'px', height: this.scaleBlockSize+'px'}"
           class="se scaleIcon"></div>

    </div>

		
	</div>
</template>
<script>
import {
  isDownArrowDown,
  isLeftArrowDown,
  isRightArrowDown,
  isPaste,
  isCopy,
  isUpArrowDown,
  isDeleteDown,
  isShiftDown
} from "@/components/ProductComponents/Config/keyBoardEvents";

export default {
  name: "ComponentsWrapper",
  props: {
    allCompsJson:Object,
    //是否该组件不可移动
    isLock:{
      type: Boolean,
      default: false
    },
    // 可编辑，主要用来区分编辑模式和查看模式（现在只写了编辑模式）
    editable: {
      type: Boolean,
      default: false
    },
    // 是否正在编辑
    editing: {
      type: Boolean,
      default: false
    },
    // 是否在多选 editing里面:
    multiEditing: {
      type: Boolean,
      default: false
    },
    // 当前组件的属性设置
    settings: {
      type: Object,
    },
    wrapperStyle: {
      type: Object,
    },
  },
  data() {
    return {
      borderColor: '1px solid transparent',
      scaleBlockSize: 6,
      wrapperColor: "#000000",
      wrapperStyleMergeObj: {},
      wrapperStyleMergeinfo: {},        // 记录元素的长宽位置信息的值
      documentClick: undefined,
      startMoveFlag: false,
      startScaleFlag: false,
      cloneWrapper: {},

      copyFlag: true, //防止误操作
      pasteFlag: true, //
      deleteFlag: true,
    }
  },
  mounted() {
    this.clearDocumentClickEvent()
    this.init()
  },
  // 销毁前把绑定的事件去除
  beforeDestroy() {
    this.clearDocumentClickEvent()
  },
  methods: {
			init() {
        //用户手动把isLock置为true：
        //不能拖动修改大小，但是可以手动输入
        //边框样式修改
        //禁用鼠标点击事件
        if (this.isLock){
          this.wrapperColor = "#FF0000";
        }else{
          this.wrapperColor = "#000000";
        }
        // 点击该wrapper 以外的地方 editing置为false
        if (this.editable) {
						//console.log(this.$el.id, "绑定 点击时更新 editing ")
						this.documentClick = (e) => {
							if (e.path.indexOf(this.$el) === -1) {
                this.$emit("update:editing", false)
							}
						}
						document.addEventListener('click', this.documentClick)
        }
        let left = this.$el.offsetLeft
        let top = this.$el.offsetTop
        let width = this.$el.clientWidth
        let height = this.$el.clientHeight
        this.wrapperStyleMergeObj = {
          left: left+"px",
          top: top+"px",
          width: width+"px",
          height: height+"px",
        }
			},
			clearDocumentClickEvent() {
				document.removeEventListener('click', this.documentClick)
			},
			clickOnWrapper() {
				if(this.editable === true){
          //如果该组件已上锁，则边框变红
					this.$emit("update:editing", true)
        }
			},
			
			// 拖动已摆放元素时，鼠标按下的回调函数
			mouseDownOnSelf(e) {
        //this.clickOnWrapper();
        if(this.isLock){
          return;
        }
        if(!this.multiEditing){
          return;
        }

        //console.log('选中组件ing，e=',e.currentTarget.id)

				/* clientX: 鼠标按下时的x坐标（相对于整个窗口），clientY同理
			  el.offsetLeft、offsetTop：该元素的相对于父元素中第一个position不是static的元素的偏移，这里是相对于content画布的偏移（具体可以百度）
			  sX、sY、sLeft、sTop: s表示start 起始状态*/
        if (!this.editable) return
				//console.log("mouseDownOnSelf")
        var sX = e.clientX
        var sY = e.clientY
        this.startMoveFlag = true   // 按下鼠标（开始拖动）后，给document绑定mousemove事件，鼠标移动就会调用下面的回调函数。
        document.onmousemove = (e) => {
          // cX, cY, cLeft, cTop: c表示current，是指鼠标移动到当前位置时的数据
          e.preventDefault()
          let cX = e.clientX - sX
          let cY = e.clientY - sY
          sX = e.clientX;
          sY = e.clientY;
          if(this.startMoveFlag && cX !== sX && cY !== sY) {
            this.startMoveFlag = false
            this.emitPositionChangeStart()
          }
          // (cX - sX)是当前x与开始拖动时x的差值，也就是在x轴上移动了多少距离
          this.emitPositionChange({
            leftOffset: cX,
            topOffset: cY
          })
        }
        // 松开鼠标（拖动结束）后，解绑上面的mousemove事件
        document.onmouseup = () => {
					//console.log("mouseUP保存值")
          this.$bus.$emit('saveInfo')
          this.emitPositionChangeStop()
          document.onmousemove = null
					document.onmouseup = null
          this.startMoveFlag = false
        }
			},
			
			handleKeyDownEvents(keyDownFlag){
        if(this.multiEditing){
          if(isShiftDown(keyDownFlag)){
            if (isLeftArrowDown(keyDownFlag)) {
              this.emitWrapperResize("left");
            }
            if (isRightArrowDown(keyDownFlag)) {
              this.emitWrapperResize("right");
            }
            if (isUpArrowDown(keyDownFlag)) {
              this.emitWrapperResize("up");
            }
            if (isDownArrowDown(keyDownFlag)) {
              this.emitWrapperResize("down");
            }
          }
          //按下键盘的上下左右移动
          else
          {
            if (isLeftArrowDown(keyDownFlag)) {
              this.emitWrapperMove("left");
              //this.$bus.$emit('saveInfo')
            }
            if (isRightArrowDown(keyDownFlag)) {
              this.emitWrapperMove("right");
              //this.$bus.$emit('saveInfo')
            }
            if (isUpArrowDown(keyDownFlag)) {
              this.emitWrapperMove("up");
              //this.$bus.$emit('saveInfo')
            }
            if (isDownArrowDown(keyDownFlag)) {
              this.emitWrapperMove("down");
              //this.$bus.$emit('saveInfo')
            }
          }
          if(isCopy(keyDownFlag) && this.copyFlag){
            console.log("复制");
            this.copyFlag = false;
          }
          if(isPaste(keyDownFlag) && this.pasteFlag){
            this.emitCloneWrapper();
            console.log("粘贴");
            this.pasteFlag = false;
          }
          if(isDeleteDown(keyDownFlag) && this.deleteFlag){
            this.$emit("deleteKeyDown", this.$el.id)
            this.deleteFlag = false;
          }
          return;
        }
      },

      handleKeyUpEvents(){
        this.copyFlag = true;
        this.pasteFlag = true;
        this.deleteFlag = true;
      },

      // 鼠标移动更新位置形状
      updateLocation(attArray,isLeft,isTop,isWidth,isHeight,sX,sY,dir) {
        document.onmousemove = (e) => {
          let cX = e.clientX
          let cY = e.clientY
          let left = attArray[0]
          let top = attArray[1]
          let width = attArray[2]
          let height = attArray[3]
          let dx = cX - sX
          let dy = cY - sY
          // if (dx < 0) dx = 0
          // if (dy < 0) dy = 0;
          if(this.startScaleFlag && cX !== sX && cY !== sY) {
            this.startScaleFlag = false
            this.emitSizeChangeStart()
          }
          if (isLeft === 1) left = attArray[0] + dx
          if (isTop === 1) top = attArray[1] + dy
          if (isWidth === 1) {
            if (dir === "nw" || dir === "w" || dir === "sw") width = attArray[2] - dx
            else width = attArray[2] + dx;
            if (width < 0) width = 0;
          }
          if (isHeight === 1) {
            if (dir === "nw" || dir === 'n' || dir === 'ne') height = attArray[3] - dy
            else height = attArray[3] + dy;
            if (height < 0) height = 0;
          }
          this.wrapperStyleMergeObj = {
            left: left+"px",
            top: top+"px",
            width: width+"px",
            height: height+"px",
          }
          this.emitSizeChange()
        }
      },
			// 缩放
			mouseDownOnScale(e, dir) {
				if(this.isLock){
          return;
        }
				console.log("进入缩放逻辑")
				e.stopPropagation()
				let sX = e.clientX;
				let sY = e.clientY;
				let sLeft = this.$el.offsetLeft
				let sTop = this.$el.offsetTop
				let sWidth = this.$el.clientWidth
				let sHeight = this.$el.clientHeight
        let attArray = [sLeft,sTop,sWidth,sHeight]
				this.startScaleFlag = true
        if (dir === 'nw') this.updateLocation(attArray,1,1,1,1,sX,sY,dir);
        else if (dir === 'ne') this.updateLocation(attArray,0,1,1,1,sX,sY,dir);
        else if (dir === 'sw') this.updateLocation(attArray,1,0,1,1,sX,sY,dir);
        else if (dir === 'se') this.updateLocation(attArray,0,0,1,1,sX,sY,dir);
        else if (dir === 'n') this.updateLocation(attArray,0,1,0,1,sX,sY,dir);
        else if (dir === 'w') this.updateLocation(attArray,1,0,1,0,sX,sY,dir);
        else if (dir === 'e') this.updateLocation(attArray,0,0,1,0,sX,sY,dir);
        else if (dir === 's') this.updateLocation(attArray,0,0,0,1,sX,sY,dir);
				document.onmouseup = (e) => {
          console.log("更新值的逻辑执行")
          this.$bus.$emit('saveInfo')
					e.stopPropagation()
					this.emitSizeChangeStop()
					if (e.target.classList.contains("scaleIcon") !== -1) {
						document.onmousemove = null;
					}
					document.onmouseup = null
					this.startScaleFlag = false
				}
			},
			emitSizeChangeStart() {
				this.$emit('resize-start', this.$el.id)
			},

      //复制组件
			emitCloneWrapper(){
				this.$emit('cloneWrapper', this.$el.id, this.wrapperStyleMergeObj)
				this.$bus.$emit('cloneWrapper', this.$el.id, this.wrapperStyleMergeObj)
			},
			emitWrapperMove(moveDirection){
				this.$emit('wrapperMove', this.$el.id, this.wrapperStyleMergeObj,moveDirection)
				this.$bus.$emit('wrapperMove', this.$el.id, this.wrapperStyleMergeObj,moveDirection)
			},
			emitWrapperResize(moveDirection){
				this.$emit('wrapperResize', this.$el.id, this.wrapperStyleMergeObj,moveDirection)
				this.$bus.$emit('wrapperResize', this.$el.id, this.wrapperStyleMergeObj,moveDirection)
			},
			// size改变过程中不断emit
			emitSizeChange() {
				this.$emit('resize', this.$el.id, this.wrapperStyleMergeObj)
				this.$bus.$emit('resize', this.$el.id, this.wrapperStyleMergeObj)
			},
			// size改变停止后（拖拽的鼠标松开后）emit
			emitSizeChangeStop() {

			},
			emitPositionChangeStart() {
				this.$emit('reposition-start', this.$el.id)
			},
			// 位置改变过程中不断emit
      // 多选修改位置
			emitPositionChange(obj) {
				this.$emit("multi-reposition", obj);
			},
			// 位置改变停止后（拖拽的鼠标松开后）emit
			emitPositionChangeStop() {
        //this.$emit('reposition', this.$el.id, this.wrapperStyle)
			},
		},
		watch: {
      wrapperStyle: {
        immediate: true,
        handler() {
          this.wrapperStyleMergeinfo.width = parseInt(this.wrapperStyle.width.replace("px",""));
          this.wrapperStyleMergeinfo.height = parseInt(this.wrapperStyle.height.replace("px",""));
          this.wrapperStyleMergeinfo.top = parseInt(this.wrapperStyle.top.replace("px",""));
          this.wrapperStyleMergeinfo.left = parseInt(this.wrapperStyle.left.replace("px",""));
        }
      },
			editable: {
				handler() {
					this.clearDocumentClickEvent()
					this.init()
				}
			},
      editing: {
        handler() {
          if(this.editing || this.multiEditing){
            if(this.isLock){
              this.borderColor = '1px solid #FF0000'
            }else{
              this.borderColor = '1px solid black'
            }
          }else{
            this.borderColor = '1px solid transparent'
          }
        }
      },
      multiEditing: {
        handler() {
          if(this.editing || this.multiEditing){
            if(this.isLock){
              this.borderColor = '1px solid #FF0000'
            }else{
              this.borderColor = '1px solid black'
            }
          }else{
            this.borderColor = '1px solid transparent'
          }
        }
      },
      isLock:{
        handler() {
          this.init()
        }
      }
		}
	}
</script>

<style lang="less" scoped>
	.componentsWrapper {
		// border: 1px solid transparent;
		min-width: 20px;
		min-height: 20px;
		&.editing {
			border: 1px dashed black;
			cursor: move;
		}
		.wrapped {
			width: 100%;
			height: 100%;
		}
		.scaleIcon {
			position: absolute;
			z-index: 100;
			&.nw {
				cursor: nw-resize;
				left: 0;
				top: 0;
				// right: 0;
				// bottom: 0;
			}

			&.ne {
				cursor: ne-resize;
				right: -2px;
				top: 0;
			}

			&.sw {
				cursor: ne-resize;
				left: 0;
				bottom: -2px;
			}

			&.se {
				cursor: nw-resize;
				right: -2px;
				bottom: -2px;
			}

      &.n {
        cursor: n-resize;
        top: 0;
      }

      &.w {
        cursor: w-resize;
        left: 0;
      }
      &.e {
        cursor: e-resize;
        right: -2px;
      }
      &.s {
        cursor: s-resize;
        bottom: -2px;
      }
		}

	}
</style>
